/**
 * SharePoint dev logging delegates to `sharepointDebugLog.local.ts` (committed no-ops; edit locally for verbose logs).
 */
import type { SharepointEwaWorkbookContext } from 'lib/api/getSharepointWorkbookEwaContext';

import type { SharepointWorkbookRowsResponse } from '../types/SharepointWorkbookRows';

export type SharepointWorkbookRowsLogOpts = {
  hostTabId?: number;
  worksheetQueryParam?: string;
};

type LocalModule = typeof import('./sharepointDebugLog.local');

let localModulePromise: Promise<LocalModule | null> | null = null;

function loadLocalModule(): Promise<LocalModule | null> {
  if (localModulePromise != null) {
    return localModulePromise;
  }
  localModulePromise = import('./sharepointDebugLog.local')
    .then((m) => m)
    .catch(() => null);
  return localModulePromise;
}

export function logSharepointWorksheetSelectionDev(payload: {
  hostTabId?: number;
  documentUrl: string;
  ewaFromServiceWorker: SharepointEwaWorkbookContext | null;
  worksheetForApi?: string;
}): void {
  void loadLocalModule().then((m) => {
    m?.logSharepointWorksheetSelectionDev(payload);
  });
}

export function logSharepointWorkbookRowsDev(
  documentUrl: string,
  data: SharepointWorkbookRowsResponse,
  opts?: SharepointWorkbookRowsLogOpts
): void {
  void loadLocalModule().then((m) => {
    m?.logSharepointWorkbookRowsDev(documentUrl, data, opts);
  });
}
